import roles from '@/settings/roles';

export default [
  {
    path: 'locations',
    name: 'org-admin-locations',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Locations.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'org-reports',
    name: 'org-reports',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/OrgReports.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'mail',
    name: 'admin-mail',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Mail.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'new-mail',
    name: 'admin-new-mail',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/NewMail.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'smart-mail',
    name: 'admin-smart-mail',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/SmartMail.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'mail-group',
    name: 'admin-edit-mail-group',
    alias: 'new-mail-group',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/MailGroup.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'mail-forwarding',
    name: 'admin-mail-forwarding',
    alias: 'group-forwarding',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/MailForwarding.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'mail-edit',
    name: 'admin-mail-edit',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/MailEdit.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'tracking',
    name: 'admin-tracking',
    component: () => import('@/views/admin/pages/Tracking.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'view-mode',
    name: 'admin-view-mode',
    component: () => import('@/views/admin/pages/SeePlans.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'account',
    name: 'admin-account',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Account.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'settings',
    name: 'admin-settings',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Settings.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'customers',
    name: 'admin-customers',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Customers.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'customer',
    redirect: 'customers'
  },
  {
    path: 'customer/:id',
    name: 'admin-customer',
    component: () => import (/* webpackPrefetch: true */ '@/views/admin/pages/Customer.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'customer/:id/phone-select',
    name: 'admin-phone-select',
    component: () => import ('@/views/admin/pages/customer/PhoneSelect.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'customer/:id/phone-setup/:phone_id',
    name: 'admin-phone-setup',
    component: () => import('@/views/admin/pages/customer/PhoneSetup.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'customer/:id/port-number',
    name: 'admin-port-number',
    component: () => import('@/views/admin/pages/customer/PortNumber.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'customer/:id/update-plan',
    name: 'admin-plan-update',
    component: () => import('@/views/admin/pages/customer/UpdatePlan.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'add-customer',
    name: 'admin-add-customer',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customers/AddCustomer.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'activate-customer/:id',
    name: 'admin-activate-customer',
    component: () => import(/* webpackPrevetch: true */ '@/views/admin/pages/customers/ActivateCustomer.vue'),
    meta: {
      forAuth: true
    }
  },
  {
    path: 'reports',
    name: 'admin-reports',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Reports.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'report-details',
    name: 'admin-report-details',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/ReportDetails.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'report-revenue',
    name: 'admin-report-revenue',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/ReportRevenue.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'report-phone-revenue',
    name: 'admin-report-phone-revenue',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/ReportPhoneRevenue.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'report-chargebacks',
    name: 'admin-report-chargebacks',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/ReportChargebacks.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'messages',
    name: 'admin-messages',
    component: () => import('@/views/admin/pages/messages/Messages.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'notifications',
    name: 'manager-notifications',
    component: () => import('@/views/admin/pages/EditNotifications.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'announcements',
    name: 'manager-announcements',
    component: () => import('@/views/admin/pages/EditAnnouncements.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  },
  {
    path: 'email-customers',
    name: 'admin-email-customers',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/Emails.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'clients',
    name: 'clients',
    component: () => import(/* webpackPrefetch: true */ '@/views/admin/pages/operators/Operators.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    },
  },
  {
    path: 'errors',
    name: 'manager-errors',
    component: () => import('@/views/admin/pages/ErrorsList.vue'),
    meta: {
      forAuth: true,
      roles: [roles.admin]
    }
  }
]